import { ForwardedRef, forwardRef } from 'react';
import { tv } from 'tailwind-variants';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  ref?: ForwardedRef<HTMLDivElement>;
}

const cardStyle = tv({
  slots: {
    card: 'border bg-white border-gray-300 rounded-xl px-6 py-4',
  },
});

export const Card = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const { card } = cardStyle();

  const { className, ...rest } = props;

  return <div className={card({ className })} ref={ref} {...rest} />;
});

Card.displayName = 'Card';
